/**
 * Decode a JWT payload segment. JWT segments are base64url (RFC 4648 §5)
 * — `-`/`_` in place of `+`/`/`, no padding — not the standard base64
 * alphabet `atob` expects, so a plain `atob(jwt.split('.')[1])` throws on
 * the majority of real tokens. Normalizes before decoding.
 *
 * Read-only, client-side use only (UI display / highlighting) — never a
 * substitute for server-side signature verification or an authorization
 * decision.
 */
export function decodeJwtPayload<T = Record<string, unknown>>(jwt: string): T | null {
  try {
    const payloadSegment = jwt.split('.')[1];
    if (!payloadSegment) return null;
    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64.padEnd(base64.length + (4 - (base64.length % 4)) % 4, '=');
    return JSON.parse(atob(padded)) as T;
  } catch {
    return null;
  }
}
